var _path, _circle, _circle2, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 663,
    viewBox: "0 0 834 663",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 0L590.597 474.75H42.403L316.5 0Z",
    fill: "#E5E5E5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 633,
    cy: 462,
    r: 201,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 433,
    cy: 476,
    r: 123,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 440,
    width: 448,
    height: 78,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440.455 533.545C431.182 533.545 422.985 532.273 415.864 529.727C408.742 527.212 402.758 523.5 397.909 518.591C393.061 513.682 389.394 507.667 386.909 500.545C384.424 493.424 383.182 485.273 383.182 476.091C383.182 467.212 384.439 459.273 386.955 452.273C389.5 445.273 393.182 439.333 398 434.455C402.848 429.545 408.727 425.803 415.636 423.227C422.576 420.652 430.424 419.364 439.182 419.364C447.697 419.364 455.152 420.758 461.545 423.545C467.97 426.303 473.333 430.045 477.636 434.773C481.97 439.47 485.212 444.758 487.364 450.636C489.545 456.515 490.636 462.576 490.636 468.818C490.636 473.212 490.424 477.667 490 482.182C489.576 486.697 488.682 490.848 487.318 494.636C485.955 498.394 483.848 501.424 481 503.727C478.182 506.03 474.364 507.182 469.545 507.182C467.424 507.182 465.091 506.848 462.545 506.182C460 505.515 457.742 504.409 455.773 502.864C453.803 501.318 452.636 499.242 452.273 496.636H451.727C451 498.394 449.879 500.061 448.364 501.636C446.879 503.212 444.924 504.47 442.5 505.409C440.106 506.348 437.182 506.758 433.727 506.636C429.788 506.485 426.318 505.606 423.318 504C420.318 502.364 417.803 500.152 415.773 497.364C413.773 494.545 412.258 491.288 411.227 487.591C410.227 483.864 409.727 479.848 409.727 475.545C409.727 471.455 410.333 467.712 411.545 464.318C412.758 460.924 414.439 457.955 416.591 455.409C418.773 452.864 421.318 450.833 424.227 449.318C427.167 447.773 430.333 446.818 433.727 446.455C436.758 446.152 439.515 446.288 442 446.864C444.485 447.409 446.53 448.242 448.136 449.364C449.742 450.455 450.758 451.667 451.182 453H451.727V447.909H461.364V489C461.364 491.545 462.076 493.788 463.5 495.727C464.924 497.667 467 498.636 469.727 498.636C472.818 498.636 475.182 497.576 476.818 495.455C478.485 493.333 479.621 490.061 480.227 485.636C480.864 481.212 481.182 475.545 481.182 468.636C481.182 464.576 480.621 460.576 479.5 456.636C478.409 452.667 476.742 448.955 474.5 445.5C472.288 442.045 469.485 439 466.091 436.364C462.697 433.727 458.712 431.667 454.136 430.182C449.591 428.667 444.424 427.909 438.636 427.909C431.515 427.909 425.136 429.015 419.5 431.227C413.894 433.409 409.121 436.606 405.182 440.818C401.273 445 398.288 450.091 396.227 456.091C394.197 462.061 393.182 468.848 393.182 476.455C393.182 484.182 394.197 491.045 396.227 497.045C398.288 503.045 401.318 508.106 405.318 512.227C409.348 516.348 414.333 519.47 420.273 521.591C426.212 523.742 433.061 524.818 440.818 524.818C444.152 524.818 447.439 524.5 450.682 523.864C453.924 523.227 456.788 522.53 459.273 521.773C461.758 521.015 463.545 520.455 464.636 520.091L467.182 528.455C465.303 529.242 462.848 530.03 459.818 530.818C456.818 531.606 453.606 532.258 450.182 532.773C446.788 533.288 443.545 533.545 440.455 533.545ZM435.182 497.364C439.242 497.364 442.53 496.545 445.045 494.909C447.561 493.273 449.394 490.803 450.545 487.5C451.697 484.197 452.273 480.03 452.273 475C452.273 469.909 451.636 465.939 450.364 463.091C449.091 460.242 447.212 458.242 444.727 457.091C442.242 455.939 439.182 455.364 435.545 455.364C432.091 455.364 429.136 456.273 426.682 458.091C424.258 459.879 422.394 462.273 421.091 465.273C419.818 468.242 419.182 471.485 419.182 475C419.182 478.879 419.697 482.53 420.727 485.955C421.758 489.348 423.439 492.106 425.773 494.227C428.106 496.318 431.242 497.364 435.182 497.364Z",
    fill: "#E2E2E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 594,
    y: 462,
    width: 27,
    height: 27,
    fill: "#E2E2E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 552,
    y: 462,
    width: 27,
    height: 27,
    fill: "#E2E2E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 636,
    y: 462,
    width: 27,
    height: 27,
    fill: "#E2E2E2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 678,
    y: 462,
    width: 27,
    height: 27,
    fill: "#E2E2E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 720,
    y: 462,
    width: 27,
    height: 27,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 763,
    y: 462,
    width: 27,
    height: 27,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M806 462H833V489H806V462Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a2ceb13f6b43846a29bf512173db9714.svg";
export { ForwardRef as ReactComponent };